import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TDeleteEmployeeChecksRequestSchema,
  TDeleteEmployeeChecksResponseSchema,
} from "./deleteEmployeeChecks.schema";

export const deleteEmployeeChecks = (axios: IAxiosInstance) => {
  return async (body: TDeleteEmployeeChecksRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TDeleteEmployeeChecksResponseSchema>
    >(`/api/delete-employee-checks`, body);

    return response.data;
  };
};
